export const discountConstants = {
    
    GET_DISCOUNTS_REQUEST: 'GET_DISCOUNTS_REQUEST',
    GET_DISCOUNTS_SUCCESS: 'GET_DISCOUNTS_SUCCESS',
    GET_DISCOUNTS_FAILURE: 'GET_DISCOUNTS_FAILURE',

    ADD_DISCOUNT_REQUEST: 'ADD_DISCOUNT_REQUEST',
    ADD_DISCOUNT_SUCCESS: 'ADD_DISCOUNT_SUCCESS',
    ADD_DISCOUNT_FAILURE: 'ADD_DISCOUNT_FAILURE'
    
};
